import Tabs from "./tabs";
import welcomeApp from "../templates/welcome.svelte";
import listTephraSnippets from "../templates/listTephraSnippets.svelte";
import TephraSVG from "../stylesheets/images/tephra.svg";

window.Panes = (function() {
  function Pane() {
    this.init();
  }
  Pane.GUID = () => {
    function s4() {
      return Math.floor((1 + Math.random()) * 0x10000)
        .toString(16)
        .substring(1);
    }
    return "pane-" + s4() + "-" + s4();
  };

  Pane.prototype.init = function() {
    let GoldenLayout = require("golden-layout");
    let utilstackConfig = {
      type: "stack",
      id: "utilStack",
      height: 10,
      componentName: "utilStack",
      reorderEnabled: false
    };

    let config = {
      settings: {
        showPopoutIcon: false,
        constrainDragToContainer: true
      },
      dimensions: {
        dragProxyWidth: 10,
        dragProxyHeight: 10,
        headerHeight: 31
      },
      content: [
        {
          type: "row",
          selectionEnabled: false,
          id: "main-row",
          content: [
            {
              isClosable: false,
              type: "stack",
              id: "navStack",
              componentName: "navStack",
              height: 90,
              content: [
                {
                  id: "tree",
                  isClosable: false,
                  width: 20,
                  type: "component",
                  componentName: "tree component",
                  reorderEnabled: false,
                  componentState: {
                    label: "tree-pane-component",
                    id: "tree"
                  },
                  editor_id: "tree"
                }
              ]
            },
            {
              type: "column",
              selectionEnabled: false,
              width: 80,
              isClosable: false,
              id: "main-col",
              content: [
                {
                  isClosable: false,
                  type: "stack",
                  id: "contentStack",
                  componentName: "contentStack",
                  height: 90,
                  content: [
                    {
                      type: "component",
                      componentName: "welcome component",
                      id: "welcome",
                      key: "-1",
                      title: "welcome",
                      reorderEnabled: true,
                      componentState: {
                        id: "welcome"
                      }
                    }
                  ]
                },
                utilstackConfig
              ]
            }
          ]
        }
      ]
    };

    Panes = new GoldenLayout(config, ".editor-wrapper");

    Panes.registerComponent("tree component", function(container, componentState) {
      container.getElement().html("<div id=" + componentState.label + ' class="tree-view"></div>');
    });
    Panes.registerComponent("tephra", function(container, componentState) {
      new listTephraSnippets({ target: container.getElement()[0], props: { label: componentState.label } });
    });
    Panes.registerComponent("util component", function(container) {
      container.getElement().hide();
    });
    Panes.registerComponent("contentStack", function(container) {
      container.getElement().attr("id", "contentStack");
    });
    // eslint-disable-next-line no-unused-vars
    Panes.registerComponent("welcome component", function(container, componentState) {
      console.log({ container });
      new welcomeApp({
        target: container.getElement()[0]
      });
    });
    Panes.registerComponent("generic component", function(container) {
      container.getElement().attr("id", "codeSearch-wrapper");
    });
    Panes.registerComponent("image view", function(container) {
      container.getElement().attr({
        class: "image-viewer",
        id: container._config.id
      });
    });

    Panes.registerComponent("editor component", function(container, componentState) {
      container.getElement().html("<div id=" + componentState.id + ' class="code-editor"></div>');

      // TODO refactor into function
      typeof window.selectedNode !== "undefined" && window.selectedNode.toggleSelected();
      // window.selectedNode = tree.getNodeByKey(container.parent.config.key);
      CodeEditor.Tree.selectNode(container.parent.config.key);
      window.selectedNode.toggleSelected();
      Panes.root.ActiveNode = container.parent;
      // END - TODO  refactor into function

      container.on("tab", function(tab) {
        const { tooltip, fileType, key } = tab.contentItem.config;
        if (fileType === "tephra_snippet") tab.element.prepend($(`<img src=${TephraSVG} class='tephra_svg'>`));
        tab.element.append($('<div tab_key="' + key + '" class="file_save loaded"></div>'));
        tab.element.attr({ title: tooltip, type: fileType, tab_id: tooltip });
        tab.closeElement.off("click").bind("click", function() {
          Tabs.close(tab);
        });
        tab._onCloseClick = () => true;
        tab.element.mousedown("mousedown touchstart", function(e) {
          if (e.button === 1) {
            Tabs.close(tab);
          }
        });
        tab.element.on("click", function() {
          // TODO refactor into function
          typeof window.selectedNode !== "undefined" && window.selectedNode.toggleSelected();
          if (tree.getNodeByKey(String(key)) === null) {
            alert("an error accorded, contact support");
          }
          // window.selectedNode = tree.getNodeByKey(String(key));
          CodeEditor.Tree.selectNode(key);
          // window.selectedNode.toggleSelected();
          Panes.root.ActiveNode = Panes.root.getItemsById(tooltip)[0];
          // END - TODO  refactor into function
        });
      });
    });
    Panes.on("stateChanged", (component, s) => {
      console.log(component, "background-color:#66d9ef");
      console.log(s);
      if (editors.length > 0) {
        CodeEditor.resize();
      }
      // FH.isActive
      if (typeof fileHistory !== "undefined" && fileHistory.tab && fileHistory.tab !== Tabs.getActiveTab()) {
        fileHistory.close();
      }
      if (Panes.emptyStacks().length > 0) {
        document.getElementById(Panes.emptyStacks()[0].editor).style.display = "none";
      }
    });
    /*
     * {event} stackCreated fires when a new stack is created
     * on every stack created, 1  new instance of the editor should be created
     *
     */
    Panes.on("stackCreated", function(stack) {
      console.log(stack.parent);
      if (stack.config.id) {
        stack.element[0].id = stack.config.id;
      }
      stack.element.on("click", function() {
        let stack_editor = $(this).find(".ace_editor");
        if (stack_editor.length > 0) {
          editor = CodeEditor.getEditorById(stack_editor[0].id);
        }
        if (stack.getActiveContentItem().componentName !== "tree component") {
          Panes.root.ActiveNode = stack.getActiveContentItem();
        }
      });

      stack.on("activeContentItemChanged", function(component) {
        Panes.root.ActiveNode = component;
        let waitForTab;
        console.log("%c activeContentItemChanged", "background-color:#311b92");
        if (component.componentName === "editor component") {
          CodeEditor.Tree.selectNode(String(component.config.key));
          const displayStackEditor = () => {
            if (typeof stack.editor !== "undefined" && component.componentName === "editor component") {
              if (typeof selectedNode != "undefined") {
                CodeEditor.Tree.selectNode(component.config.key);
                if (typeof selectedNode.data?.content !== "undefined") {
                  editor = CodeEditor.getEditorById(stack.editor);
                  CodeEditor.Main.updateEditor(component.config.node, false);
                  CodeEditor.Main.refreshContent();
                }
              }
              CodeEditor.show();
            }
          };
          if (component.config.id !== "tree" && typeof stack.editor === "undefined") {
            const genID = Pane.GUID();
            waitForTab = setInterval(function() {
              if (document.getElementById(component.config.id) != null) {
                console.log("interval");
                if (stack.editor) {
                  clearInterval(waitForTab);
                  return true;
                }
                stack.element.append('<div id="' + genID + '"/>');
                CodeEditor.Main.attachEditor(genID);
                CodeEditor.hide();
                console.log("stack editor");
                stack.editor = genID;
                $("#" + genID).on("click.stack", function() {
                  let nodeToSelect = Panes.getStackByEditor($(this)[0].id).header.activeContentItem.config.key;
                  if (nodeToSelect) {
                    CodeEditor.Tree.selectNode(nodeToSelect);
                  }
                });
                displayStackEditor();
                clearInterval(waitForTab);
              } else {
                console.log(document.getElementById(component.config.id));
              }
            }, 1);
          }
          displayStackEditor();
        } else if (typeof stack.editor !== "undefined") {
          console.log("%c editor " + stack.editor + " selected", "background-color: green; color: #fff;");
          editor = CodeEditor.getEditorById(stack.editor);
          CodeEditor.hide();
        }
      });
    });

    Panes.on("componentCreated", function(component) {
      // console.log(component);
      if (component.componentName !== "tree component") {
        Panes.root.ActiveNode = component;
      }
    });

    Panes.on("itemDestroyed", function(component) {
      console.log(component.componentName);
      let stack = component.parent;
      if (component.isStack && editors.length > 1) {
        console.log(component.editor);
        editors = editors.filter(e => e.container.id !== String(component.editor));
        editor = editors[0];
        component.element.off("click");
      } else {
        editor = CodeEditor.getEditorById(stack.editor);
      }
      if (typeof editor != "undefined") {
        editor = CodeEditor.getEditorById(stack.editor);
      }
      if (typeof selectedNode != "undefined" && CodeEditor.Tree.getNodePath(selectedNode) === component.config.id) {
        selectedNode.toggleSelected();
        selectedNode = undefined;
      }
      if (stack.contentItems.length === 1 && typeof stack.editor !== "undefined") {
        CodeEditor.hide();
      }
    });

    Panes.on("initialised", () => {
      Panes.root._$onDrop = contentItem => {
        let stack;
        if (contentItem.isComponent) {
          stack = Panes.getLastStack();
          stack.addChild(contentItem);
          contentItem = stack;
        }
      };

      CodeEditor.Main.bindCommands();
    });

    Panes.codePaneChildren = () => Panes.root.contentItems[0].contentItems[1].contentItems;
    Panes.getLastStack = () => {
      let stack = getLastItem(Panes.root.getItemsById("contentStack")[0]);
      /**
       * @function getLastItem
       * @param  {type} stack {description}
       * @return {type} {description}
       */
      function getLastItem(stack) {
        if (stack?.contentItems?.length && typeof stack?.contentItems.last().contentItems.last() === "undefined") {
          if (stack.contentItems.last().config.type === "component") return stack.contentItems.last();
          else return null;
        } else {
          return stack?.contentItems?.length ? getLastItem(stack.contentItems.last()) : stack;
        }
      }
      return stack;
    };

    Panes.getStackByEditor = id => {
      return Panes.root.getItemsByType("stack").find(stack => stack.editor && stack.editor === id);
    };
    Panes.emptyStacks = () =>
      Panes.root.getItemsByFilter(i => i.editor && i.contentItems.length === 0 && i.type === "stack");
    Panes.addUtilStack = () => {
      Panes.root.getItemsById("main-col")[0].addChild(Object.assign({}, utilstackConfig));
    };
    Panes.init();
  };

  document.addEventListener("DOMContentLoaded", () => {
    $(window).resize(() => {
      Panes.updateSize();
    });
  });

  return Pane;
})();

export default Panes;
